import { Transform } from 'class-transformer';
import { IsDateString, IsNotEmpty, IsOptional, IsString, MaxLength, ValidateIf } from 'class-validator';

import { DeliveryAddressModel } from '../delivery-address.model';
import { ShippingSettingsModel } from '../shipping-settings.model';
import { extractPlainDate, sanitizeString } from '../utils';
import { DraftProductModel } from './draft-product.model';

export class UpdateDraftDto {
  @IsDateString()
  @IsNotEmpty()
  @Transform(({ value }) => extractPlainDate(value))
  public dueDate: string;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  @Transform(({ value }) => sanitizeString(value))
  public customerPoNumber: string;

  @IsOptional()
  @IsNotEmpty()
  @ValidateIf((body) => body?.deliveryAddress)
  public deliveryAddress?: DeliveryAddressModel;

  @IsOptional()
  @IsNotEmpty()
  public shippingSettings?: ShippingSettingsModel;

  @IsNotEmpty()
  public products: DraftProductModel[];

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @MaxLength(50)
  public contactId?: string;

  /**
   * When creating multiple pre-orders, we should be able to group them using a groupId
   * @example '9a48e37a-e9f1-43e8-a1d4-a933ef1bbb8e'
   */
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @MaxLength(50)
  public groupId?: string;

  /**
   * Order number corresponding to the order from which this draft order was cloned/created.
   * Must be a sales order number or a draft order number
   * @example SO01B0041950U
   */
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @MaxLength(50)
  public sourceOrderNumber?: string;
}
